import { useEffect, useState } from 'react'
import { EMAIL } from '../constants/site'
import { tick } from '../lib/sound'

const CopyEmail = () => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return
    const id = setTimeout(() => setCopied(false), 2000)
    return () => clearTimeout(id)
  }, [copied])

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL)
      setCopied(true)
      tick(1200)
    } catch {
      // Clipboard blocked (e.g. insecure context): fall back to the mail client.
      window.location.href = `mailto:${EMAIL}`
    }
  }

  return (
    <>
      <button type='button' onClick={copy} className='btn max-w-full flex-wrap'>
        <span className='break-all font-hand text-[1.25rem]'>{EMAIL}</span>
        <span className='bg-caption px-2 text-coal'>{copied ? 'Copied!' : 'Copy'}</span>
      </button>
      <span className='sr-only' aria-live='polite'>
        {copied ? 'Email address copied to clipboard' : ''}
      </span>
    </>
  )
}

export default CopyEmail
